import { Get, Delete, Put } from '../helpers';
import { Product } from '@/types/module.types';

export const GetProducts = async (channel: number): Promise<Product[]> => {
  return Get({ path: `/v3/admin/channel/products/${channel}` });
};

export const DeleteProductChildren = async (
  module_ids: number[],
  event_id: number
): Promise<{ products: Product[] }> => {
  return Delete({ path: `/v3/admin/products/child`, body: { module_ids, event_id } });
};

export const PromoteProductChildren = async (
  channel: number,
  module_ids: number[]
): Promise<{ products: Product[] }> => {
  return Put({ path: `/v3/admin/channel/products/template/promote-orphaned-child/${channel}`, body: { module_ids } });
};

export function UpdateProduct(
  channel: number,
  product: Product,
  globalApply = false
): Promise<{ products: Product[] }> {
  return Put({ url: `/v3/admin/channel/products/template/${channel}`, body: { product, globalApply } });
}
